export default {
    data: () => ({
        pickerOptions: {
            firstDayOfWeek: 1
        }
    }),
    computed: {
        pickerOptionsWithDisabledDate() {
            let options = {...this.pickerOptions};

            options.disabledDate = (date) => {
                return date > new Date()
            }

            return options
        }
    }
};
